import { apiClient, buildPostRequest } from './apiClient';
import {
  CommsCheckReportingRequest,
  DecommissionReportingRequest,
  InventoryCheckReportingRequest,
  SiteDecommissionReportingRequest,
  TcsoReportingRequest,
} from '../components/util';

export const atomProxyCommsCheckClient = {
  generateXmlXrinv: async (request: any) =>
    apiClient.post(`${process.env.REACT_APP_SINGLE_GENERATE_XML_PROXY_LAMBDA_URL}/xrinv`, request),

  generateXmlXritm: async (request: any) =>
    apiClient.post(`${process.env.REACT_APP_SINGLE_GENERATE_XML_PROXY_LAMBDA_URL}/xritm`, request),

  generateXmlXrdlg: async (request: any) =>
    apiClient.post(`${process.env.REACT_APP_SINGLE_GENERATE_XML_PROXY_LAMBDA_URL}/xrdlg`, request),

  getXmlXrinv: async (request: any) => apiClient.post(`${process.env.REACT_APP_SINGLE_GET_XML_PROXY_LAMBDA_URL}/xrinv`, request),

  getXmlXritm: async (request: any) => apiClient.post(`${process.env.REACT_APP_SINGLE_GET_XML_PROXY_LAMBDA_URL}/xritm`, request),

  getXmlXrdlg: async (request: any) => apiClient.post(`${process.env.REACT_APP_SINGLE_GET_XML_PROXY_LAMBDA_URL}/xrdlg`, request),
};

export const atomProxyDecommissionClient = {
  // decommission a single meter
  generateXml: async (request: any) =>
    apiClient.post(`${process.env.REACT_APP_DECOMMISSION_GENERATE_XML_PROXY_LAMBDA_URL}`, request),

  getXml: async (request: any) => apiClient.post(`${process.env.REACT_APP_DECOMMISSION_GET_XML_PROXY_LAMBDA_URL}`, request),

  // decommission a full S1 site
  s1SiteGenerateXml: async (request: any) =>
    apiClient.post(`${process.env.REACT_APP_S1_SITE_DECOMMISSION_GENERATE_XML_PROXY_LAMBDA_URL}`, request),

  s1SiteGetXml: async (request: any) =>
    apiClient.post(`${process.env.REACT_APP_S1_SITE_DECOMMISSION_GET_XML_PROXY_LAMBDA_URL}`, request),

  // used for testing locally
  fakeGenerateXml: async (request: any): Promise<Response> =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            new Response(
              JSON.stringify({
                runId: `Fake ID ${JSON.parse(request.body).chfDeviceId}`,
              }),
              {
                status: 200,
                statusText: 'OK',
                headers: {
                  'Content-Type': 'application/json',
                },
              },
            ),
          ),
        5000,
      ),
    ),

  fakeGetXml: async (request: any): Promise<Response> =>
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve(
            new Response(
              JSON.stringify({
                status: 'FAIL',
                chfDeviceId: `Fake CHF ID ${JSON.parse(request.body).runId}`,
                esmeDeviceId: `Fake ESME ID`,
                gsmeDeviceId: `Fake GSME ID`,
              }),
              {
                status: 200,
                statusText: 'OK',
                headers: {
                  'Content-Type': 'application/json',
                },
              },
            ),
          ),
        5000,
      ),
    ),
};

export const tcsoClient = {
  generateXml: async (request: any) => apiClient.post(`${process.env.REACT_APP_TCSO_GENERATE_XML_PROXY_LAMBDA_URL}`, request),

  getXml: async (request: any) => apiClient.post(`${process.env.REACT_APP_TCSO_GET_XML_PROXY_LAMBDA_URL}`, request),
};

export const reportingClient = {
  commsCheck: async (requestBody: CommsCheckReportingRequest) =>
    apiClient.post(`${process.env.REACT_APP_REPORTING_SERVICE_BASE_URL}/comms-check`, buildPostRequest(requestBody)),
  decommission: async (requestBody: DecommissionReportingRequest) =>
    apiClient.post(`${process.env.REACT_APP_REPORTING_SERVICE_BASE_URL}/decommission`, buildPostRequest(requestBody)),
  inventoryCheck: async (requestBody: InventoryCheckReportingRequest) =>
    apiClient.post(`${process.env.REACT_APP_REPORTING_SERVICE_BASE_URL}/inventory-check`, buildPostRequest(requestBody)),
  siteDecommission: async (requestBody: SiteDecommissionReportingRequest) =>
    apiClient.post(`${process.env.REACT_APP_REPORTING_SERVICE_BASE_URL}/site-decommission`, buildPostRequest(requestBody)),
  tcso: async (requestBody: TcsoReportingRequest) =>
    apiClient.post(`${process.env.REACT_APP_REPORTING_SERVICE_BASE_URL}/tcso`, buildPostRequest(requestBody)),
};
